import { render, staticRenderFns } from "./FileSelector.vue?vue&type=template&id=12c276ee&scoped=true"
import script from "./FileSelector.vue?vue&type=script&lang=js"
export * from "./FileSelector.vue?vue&type=script&lang=js"
import "./FileSelector.vue?vue&type=style&index=0&id=12c276ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c276ee",
  null
  
)

export default component.exports